import React, { Component } from 'react';

import functions from '../../../../functions/';
import ParadigmaAsyncSeeker from '../../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker';
import ParadigmaLabeledInput from '../../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput';
import api from '../../../../api/';
import ParadigmaTable from "../../../../components/ParadigmaTable/";
import { Card, CardBody, CardTitle, Col, Container, Row } from 'reactstrap';
import PreciosDelBtn from './PreciosDelBtn';

const hasValue = (name) => (document.getElementById(name) && document.getElementById(name).value != "");

class Precios extends Component {
  constructor() {
    super();
    this.state = {
      columns: [
        {
          Header: "id",
          id: "id",
          accessor: "id",
          show: false,
          private: true,
        },
        {
          Header: "Lista_id",
          id: "Lista_id",
          accessor: "Lista_id",
          lookup: "exact",
          show: false,
          private: true,
        },
        {
          Header: "Categoria_id",
          id: "Categoria_id",
          accessor: "Categoria_id",
          lookup: "exact",
          show: false,
          private: true,
        },
        {
          Header: "Marca_id",
          id: "Marca_id",
          accessor: "Marca_id",
          lookup: "exact",
          show: false,
          private: true,
        },
        {
          Header: "Proveedor_id",
          id: "Proveedor_id",
          accessor: "Proveedor_id",
          lookup: "exact",
          show: false,
          private: true,
        },
        {
          Header: "Grupo_id",
          id: "Grupo_id",
          accessor: "Grupo_id",
          lookup: "exact",
          show: false,
          private: true,
        },
        {
          Header: "Rubro_id",
          id: "Rubro_id",
          accessor: "Rubro_id",
          lookup: "exact",
          show: false,
          private: true,
        },
        {
          Header: "Linea_id",
          id: "Linea_id",
          accessor: "Linea_id",
          lookup: "exact",
          show: false,
          private: true,
        },
        {
          Header: "Lista",
          id: "nombreLista",
          accessor: "nombreLista",
          Filter: ({ filter, onChange }) => (
            <input
              type="text"
              id="filtro-nombreLista"
              className="w-100"
              onChange={event => onChange(event.target.value)}
              value={filter ? filter.value : ""}
            />
          ),
          show: true,
          filterable: true,
          width: 200,
        },
        {
          Header: "Cod. Artículo",
          id: "codigoArticulo",
          accessor: "codigoArticulo",
          Filter: ({ filter, onChange }) => (
            <input
              type="text"
              id="filtro-codigo"
              className="w-100"
              onChange={event => onChange(event.target.value)}
              value={filter ? filter.value : ""}
            />
          ),
          show: true,
          filterable: true,
          width: 100,
        },
        {
          Header: "Artículo",
          id: "nombreArticulo",
          accessor: "nombreArticulo",
          lookup: "*",
          Filter: ({ filter, onChange }) => (
            <input
              type="text"
              id="filtro-titulo"
              className="w-100"
              onChange={event => onChange(event.target.value)}
              value={filter ? filter.value : ""}
            />
          ),
          show: true,
          filterable: true,
        },
        {
          Header: "Incluye IVA",
          id: "IncluyeIVA",
          accessor: d => d.IncluyeIVA ? "SI" : "NO",
          show: true,
          filterable: true,
          lookup: "exact",
          Filter: ({ filter, onChange }) => (
            <select
              onChange={event => onChange(event.target.value)}
              style={{ width: "100%" }}
              value={filter ? filter.value : "TODOS"}>
              <option value="">TODOS</option>
              <option value={"True"}>SI</option>
              <option value={"False"}>NO</option>
            </select>
          ),
          width: 100,
          className: "text-center",
        },
        {
          Header: "Precio",
          id: "Precio",
          className: "text-right",
          accessor: d => `$ ${functions.FormatPrice(d.Precio)}`,
          show: true,
          width: 100,
        },
        {
          Header: "Precio de Oferta",
          id: "PrecioOferta",
          className: "text-right",
          accessor: d => `$ ${functions.FormatPrice(d.PrecioOferta)}`,
          show: true,
          width: 125,
        },
        {
          Header: "Desde",
          id: "FechaDesde",
          className: "text-center",
          accessor: d => functions.FormatDate(d.FechaDesde),
          show: true,
          width: 100,
        },
        {
          Header: "Hasta",
          id: "FechaHasta",
          className: "text-center",
          accessor: d => functions.FormatDate(d.FechaHasta),
          show: true,
          width: 100,
        },
        {
          Header: "Tiene Precio Por Cantidad",
          id: "TienePrecioPorCantidad",
          accessor: d => d.TienePrecioPorCantidad ? "SI" : "NO",
          show: true,
          filterable: true,
          lookup: "exact",
          Filter: ({ filter, onChange }) => (
            <select
              onChange={event => onChange(event.target.value)}
              style={{ width: "100%" }}
              value={filter ? filter.value : "TODOS"}>
              <option value="">TODOS</option>
              <option value={"True"}>SI</option>
              <option value={"False"}>NO</option>
            </select>
          ),
          width: 200,
          className: "text-center",
        },
        {
          Header: "Cantidad",
          id: "Cantidad",
          accessor: d => d.Cantidad,
          className: "text-center",
          show: true,
          width: 100,
        },
        {
          Header: "Precio Por Cantidad",
          id: "PrecioPorCantidad",
          className: "text-right",
          accessor: d => `$ ${functions.FormatPrice(d.PrecioPorCantidad)}`,
          show: true,
          width: 150,
        },
        {
          Header: "De Baja",
          id: "DeBaja",
          accessor: d => d.DeBaja ? "SI" : "NO",
          show: true,
          filterable: true,
          lookup: "exact",
          width: 100,
          className: "text-center",
          Filter: ({ filter, onChange }) => (
            <select
              onChange={event => onChange(event.target.value)}
              style={{ width: "100%" }}
              value={filter ? filter.value : "TODOS"}>
              <option value="">TODOS</option>
              <option value={"True"}>SI</option>
              <option value={"False"} selected>NO</option>
            </select>
          ),
        },
      ],
      categoria_id: null,
      marca_id: null,
      proveedor_id: null,
      grupo_id: null,
      rubro_id: null,
      linea_id: null,
      lista_id: null,

      multiSelect: true,
    };
  }

  render() {
    const {
      rubro_id, linea_id, grupo_id, lista_id,
      marca_id, proveedor_id, categoria_id,
    } = this.state;
    const { modernTheme } = this.props;

    const outerFilter = [];

    if (categoria_id != undefined && categoria_id != null) {
      outerFilter.push({
        id: 'Categoria_id',
        lookup: 'exact',
        value: categoria_id
      });
    }
    if (proveedor_id != undefined && proveedor_id != null) {
      outerFilter.push({
        id: 'Proveedor_id',
        lookup: 'exact',
        value: proveedor_id
      });
    }
    if (marca_id != undefined && marca_id != null) {
      outerFilter.push({
        id: 'Marca_id',
        lookup: 'exact',
        value: marca_id
      });
    }
    if (linea_id != undefined && linea_id != null) {
      outerFilter.push({
        id: 'Linea_id',
        lookup: 'exact',
        value: linea_id
      });
    }
    if (rubro_id != undefined && rubro_id != null) {
      outerFilter.push({
        id: 'Rubro_id',
        lookup: 'exact',
        value: rubro_id
      });
    }
    if (grupo_id != undefined && grupo_id != null) {
      outerFilter.push({
        id: 'Grupo_id',
        lookup: 'exact',
        value: grupo_id
      });
    }
    if (lista_id != undefined && lista_id != null) {
      outerFilter.push({
        id: 'Lista_id',
        lookup: 'exact',
        value: lista_id
      });
    }

    return (
      <Container fluid className="container-fluid-modif container-precios">
        <Row className="mb-2">
          <Col className="col-12">
            <Card body className="border-0 p-0 m-0">
              <CardTitle className="text-center py-2 mb-0 col-color">Filtros</CardTitle>
              <CardBody>
                <Row>
                  <Col xs={12} md={6}>
                    <ParadigmaLabeledInput
                      label="Categoria"
                      md={[2, 10]}
                      inputComponent={
                        <ParadigmaAsyncSeeker
                          url={api.gestion.articulos.categorias}
                          value={categoria_id}
                          displayField="fullName"
                          valueField="id"
                          parameters={{
                            paginationEnabled: false, sort: ["Nombre"], fields: ["id", "fullName"]
                          }}
                          onChange={data => this.setState({ categoria_id: data ? data.id : null })}
                        />
                      }
                    />
                  </Col>
                  <Col xs={12} md={6}>
                    <ParadigmaLabeledInput
                      label="Grupos"
                      md={[2, 10]}
                      inputComponent={
                        <ParadigmaAsyncSeeker
                          url={api.gestion.articulos.grupos}
                          value={grupo_id}
                          displayField="Nombre"
                          valueField="Codigo"
                          parameters={{
                            paginationEnabled: false, sort: ["Nombre"], fields: ["Codigo", "Nombre"]
                          }}
                          onChange={data => this.setState({ grupo_id: data ? data.Codigo : null })}
                        />
                      }
                    />
                  </Col>
                </Row>

                <Row>
                  <Col xs={12} md={6}>
                    <ParadigmaLabeledInput
                      label="Marcas"
                      md={[2, 10]}
                      inputComponent={
                        <ParadigmaAsyncSeeker
                          url={api.gestion.articulos.marcas}
                          value={marca_id}
                          displayField="Nombre"
                          valueField="Codigo"
                          parameters={{
                            paginationEnabled: false, sort: ["Nombre"], fields: ["Codigo", "Nombre"]
                          }}
                          onChange={data => this.setState({ marca_id: data ? data.Codigo : null })}
                        />
                      }
                    />
                  </Col>
                  <Col xs={12} md={6}>
                    <ParadigmaLabeledInput
                      label="Rubros"
                      md={[2, 10]}
                      inputComponent={
                        <ParadigmaAsyncSeeker
                          url={api.gestion.articulos.rubros}
                          value={rubro_id}
                          displayField="Nombre"
                          valueField="Codigo"
                          parameters={{
                            paginationEnabled: false, sort: ["Nombre"], fields: ["Codigo", "Nombre"]
                          }}
                          onChange={data => this.setState({ rubro_id: data ? data.Codigo : null })}
                        />
                      }
                    />
                  </Col>
                </Row>

                <Row>
                  <Col xs={12} md={6}>
                    <ParadigmaLabeledInput
                      label="Proveedores"
                      md={[2, 10]}
                      inputComponent={
                        <ParadigmaAsyncSeeker
                          url={api.gestion.articulos.proveedores}
                          value={proveedor_id}
                          displayField="Nombre"
                          valueField="Codigo"
                          parameters={{
                            paginationEnabled: false, sort: ["Nombre"], fields: ["Codigo", "Nombre"]
                          }}
                          onChange={data => this.setState({ proveedor_id: data ? data.Codigo : null })}
                        />
                      }
                    />
                  </Col>
                  <Col xs={12} md={6}>
                    <ParadigmaLabeledInput
                      label="Lineas"
                      md={[2, 10]}
                      inputComponent={
                        <ParadigmaAsyncSeeker
                          url={api.gestion.articulos.lineas}
                          value={linea_id}
                          displayField="Nombre"
                          valueField="Codigo"
                          parameters={{
                            paginationEnabled: false, sort: ["Nombre"], fields: ["Codigo", "Nombre"]
                          }}
                          onChange={data => this.setState({ linea_id: data ? data.Codigo : null })}
                        />
                      }
                    />
                  </Col>
                </Row>

                <Row>
                  <Col xs={12} md={6}>
                    <ParadigmaLabeledInput
                      label="Listas de Precio"
                      md={[2, 10]}
                      inputComponent={
                        <ParadigmaAsyncSeeker
                          url={api.gestion.precios.listas}
                          value={lista_id}
                          displayField="Nombre"
                          valueField="Codigo"
                          parameters={{
                            paginationEnabled: false, sort: ["Nombre"], fields: ["Codigo", "Nombre"]
                          }}
                          onChange={data => this.setState({ lista_id: data ? data.Codigo : null })}
                        />
                      }
                    />
                  </Col>
                </Row>

              </CardBody>
            </Card>
          </Col>
        </Row>
        <ParadigmaTable
          modernTheme={modernTheme}
          buttons={[
            {
              permission: "ecommerce_articulos_articulos_edit",
              customComponent: true,
              multiSelect: true,
              component: (props) => (
                <PreciosDelBtn
                  {...props}
                  action="RESTAURAR"
                  filters={{
                    rubro_id, linea_id, grupo_id, marca_id, proveedor_id, categoria_id, lista_id,
                    tituloInputNode: document.getElementById("filtro-titulo"),
                    codigoInputNode: document.getElementById("filtro-codigo"),
                    listaInputNode: document.getElementById("filtro-nombreLista"),
                    somethingSelected: rubro_id || linea_id || grupo_id || marca_id || proveedor_id || categoria_id || hasValue("filtro-codigo") || hasValue("filtro-titulo") || hasValue("filtro-nombreLista")
                  }}
                />
              ),
            },
            {
              permission: "ecommerce_articulos_articulos_edit",
              customComponent: true,
              multiSelect: true,
              component: (props) => (
                <PreciosDelBtn
                  {...props}
                  action="BORRAR"
                  filters={{
                    rubro_id, linea_id, grupo_id, marca_id, proveedor_id, categoria_id, lista_id,
                    tituloInputNode: document.getElementById("filtro-titulo"),
                    codigoInputNode: document.getElementById("filtro-codigo"),
                    listaInputNode: document.getElementById("filtro-nombreLista"),
                    somethingSelected: rubro_id || linea_id || grupo_id || marca_id || proveedor_id || categoria_id || hasValue("filtro-codigo") || hasValue("filtro-titulo") || hasValue("filtro-nombreLista")
                  }}
                />
              ),
            },
          ]}
          apiUrl={api.gestion.precios.precios}
          columns={this.state.columns}
          title={"Precios"}
          multiSelect={this.state.multiSelect}
          ctrlKeyMultiSelect={true}
          defaultPageSize={15}
          outerFilter={outerFilter}
        />
      </Container>
    );
  }
}

export default Precios;



// WEBPACK FOOTER //
// ./src/views/Gestion/Precios/Precios/Precios.js